<div *ngIf="show"
     @state
     [ngClass]="['snackbar-wrap',type]">
  <p class="snackbar-text">
    {{message}}
  </p>
</div>
